import { Tooltip, Typography, Box } from '@mui/material';
import type { ReactNode } from 'react';
import { QuestionCircle } from 'react-bootstrap-icons';
type Props = {
  text: NonNullable<ReactNode>;
  size?: 'sm' | 'md';
};
export function HelpText({
  text,
  size = 'md'
}: Props) {
  return <Tooltip placement="top" arrow title={<Typography variant="body2">{text}</Typography>} data-sentry-element="Tooltip" data-sentry-component="HelpText" data-sentry-source-file="HelpText.tsx">
      <Box sx={{
      mx: 1,
      cursor: 'pointer',
      display: 'inline-block',
      verticalAlign: 'middle'
    }} data-sentry-element="Box" data-sentry-source-file="HelpText.tsx">
        <QuestionCircle size={size === 'sm' ? 14 : 16} data-sentry-element="QuestionCircle" data-sentry-source-file="HelpText.tsx" />
      </Box>
    </Tooltip>;
}